<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <help :text="$t('help.emails_create')" :title="$t('help.emails_create_title')"/>

    <div
      class="white-container">
      <EmailView
        :fields="fields"
      />
    </div>
  </div>
</template>

<script>
  import fields from './emailCreationFields.js';
  import EmailView from './EmailView';

  export default {
    name: 'EmailCreation',
    components: {
      EmailView
    },
    data () {
      return {
        fields: fields
      }
    }
  }
</script>
